export enum CompanyRole {
  CLIENT = "client",
  EDITOR = "editor",
  OWNER = "owner",
  CLIENT_SELF_BOOKING = "client_self_booking",
}
